// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1F1ch","title":"FrontImage_title__kQMtU"};